import { useQuery } from '@tanstack/react-query';

import {
  VerificationDataResponse,
  getVerificationData,
} from '../../../api/account';

interface UseVerificationDataParams<T> {
  select?: (verificationDataResponse: VerificationDataResponse) => T;
}

export function useVerificationData<T = VerificationDataResponse>({
  select,
}: UseVerificationDataParams<T> = {}) {
  return useQuery({
    queryKey: ['verification-data'],
    queryFn: getVerificationData,
    select: select,
  });
}
